import React from 'react';

import styles from './counter.module.scss';

interface ICounterProps {
    count?: number;
    min?: number;
    max?: number;
}

export const Counter = ({ count = 0, max = 99, min = 0 }: ICounterProps): JSX.Element => {
    const adjustedCount = getAdjustedCount(count, max, min);

    const maxExceededIndicator = count > max ? '+' : '';

    return adjustedCount ? (
        <span className={styles.counter}>
            {adjustedCount}
            {maxExceededIndicator}
        </span>
    ) : null;
};

const getAdjustedCount = (count: number, max: number, min: number): number => {
    const adjustedCount = min || min === 0 ? Math.max(count, min) : count;

    return max ? Math.min(adjustedCount, max) : adjustedCount;
};
